import {
  CommonFilter,
  RoundedBox,
  useIsFilterApplied,
} from "@knowfully/ui.common";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { EnrollmentUsersFilter } from "services/organizationPortalClient";
import contextStore from "stores/contextStore";
import SelectProfession from "components/SelectProfession";
import SelectLicense from "components/SelectLicense";

export const emptyFilter = {
  searchText: "",
  excludeCompleted: false,
} as EnrollmentUsersFilter;

type EnrollmentUserFilterProps = {
  onChange: (filter: EnrollmentUsersFilter) => void;
};

export default function EnrollmentUserFilter({
  onChange,
}: Readonly<EnrollmentUserFilterProps>) {
  const { formatMessage: t } = useIntl();
  const { organization } = contextStore.useState();
  const [filter, setFilter] = useState(emptyFilter);
  const isFilterApplied = useIsFilterApplied(filter, []);

  useEffect(() => {
    setFilter(emptyFilter);
  }, [organization?.id]);

  // Auto-apply filters to parent on any change
  useEffect(() => {
    onChange(filter);
  }, [filter, onChange]);

  const clearFilter = () => {
    setFilter(emptyFilter);
  };

  const onChangeInternal = (prop: keyof EnrollmentUsersFilter, val: any) => {
    setFilter((prev) => ({ ...prev, [prop]: val }) as EnrollmentUsersFilter);
  };

  return (
    <RoundedBox>
      <CommonFilter
        searchText={filter.searchText}
        onSearchTextChange={(value: string | undefined) =>
          onChangeInternal("searchText", value)
        }
        searchLabel={t({ id: "searchByNameOrEmail" })}
        title={t({ id: "searchUsers" })}
        onClear={clearFilter}
        isFilterApplied={isFilterApplied}
      >
        <Grid item xs={12} sm={12} md={5}>
          <SelectProfession
            value={filter.professionIds ?? []}
            onChange={(ids) => onChangeInternal("professionIds", ids)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <SelectLicense
            value={filter.licenses ?? []}
            onChange={(val) => onChangeInternal("licenses", val)}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!filter.excludeCompleted}
                onChange={(e) =>
                  onChangeInternal("excludeCompleted", e.target.checked)
                }
              />
            }
            label={t({ id: "showOnlyUsersNeverCompleted" })}
          />
        </Grid>
      </CommonFilter>
    </RoundedBox>
  );
}
